import React, { useState } from "react"

export const RefineTypeSecondary = ({ refine_type, type, name }) => {
  const [hovered, set_hovered] = useState(false)
  const toggle_hover = () => set_hovered(!hovered)
  const count = JSON.parse(
    sessionStorage.getItem("internal_search_type_hitcount")
  )?.[type]
  return (
    <div
      onClick={refine_type}
      onKeyPress={() => {}}
      onMouseEnter={toggle_hover}
      onMouseLeave={toggle_hover}
      role="button"
      tabIndex="-1"
      aria-label="refine type secondary"
      className="level-item hit-count is-clickable refine-secondary"
    >
      {!hovered ? `insgesamt ${count}` || 0 : `Nur ${name} anzeigen`}
    </div>
  )
}
